import { render, staticRenderFns } from "./EditCookieRemarkDialog.vue?vue&type=template&id=0fe49e58&scoped=true"
import script from "./EditCookieRemarkDialog.vue?vue&type=script&lang=ts"
export * from "./EditCookieRemarkDialog.vue?vue&type=script&lang=ts"
import style0 from "./EditCookieRemarkDialog.vue?vue&type=style&index=0&id=0fe49e58&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fe49e58",
  null
  
)

export default component.exports